import React, { Component } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import config from 'config';
import Main from 'components/Main';
import GroupsAccounts from 'components/GroupsAccounts';
import Toolbar from 'components/Toolbar';
import ModalsManager from 'components/modals/ModalsManager';
import AccountsGrid from 'components/AccountsGrid';
import GroupsGrid from 'components/GroupsGrid';
import JournalsGrid from 'components/JournalsGrid';
import KpiGrid from 'components/KpiGrid';
import SettingsScreen from 'components/SettingsScreen';
import NoAccessAllowed from 'components/NoAccessAllowed';
import ErrorBoundaryFallbackRenderer from 'components/shared/ErrorBoundaryFallbackRenderer';
import { GET_REDIRECT_URL } from 'constants/urls';

import { checkIfLoggedIn, checkIfHasSubscription } from 'actions/authActions';
import { restorePreviousState } from 'actions/appActions';

import {
  HOME_PATH,
  ACCOUNTS_PATH,
  GROUPS_PATH,
  JOURNALS_PATH,
  GROUPS_ACCOUNTS_PATH,
  KPIS_PATH,
  SETTINGS_PATH,
} from 'constants/paths';

const SHOW_STATUS = {
  SHOW_NULL: 'SHOW_NULL',
  SHOW_NO_ACCESS_ALLOWED: 'SHOW_NO_ACCESS_ALLOWED',
};

//https://stackoverflow.com/a/42277886/1247955
//https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf
class App extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(checkIfLoggedIn());
    dispatch(checkIfHasSubscription());
    window.addEventListener('beforeunload', this.onExit);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onExit);
  }

  componentDidUpdate(prevProps) {
    this.redirectToAppLogin();
  }

  onExit = (e) => {
    e.preventDefault();
    const message =
      'Are you sure you want to exit? Unsaved changes may be lost.';
    e.returnValue = message;
    return message;
  };

  redirectToAppLogin = () => {
    if (config.env === 'development') {
      return;
    }

    const { hasLoadedIsLoggedIn, isLoggedIn } = this.props;

    if (hasLoadedIsLoggedIn && !isLoggedIn) {
      // Remove this and add link
      window.location.href = GET_REDIRECT_URL(config.getApiUrl())[config.env];
    }
  };

  getShowStatus = () => {
    if (config.env === 'development') {
      return;
    }

    const {
      hasLoadedIsLoggedIn,
      isLoggedIn,
      hasLoadedHasSubscription,
      hasSubscription,
    } = this.props;

    const hasLoaded =
      hasLoadedIsLoggedIn && isLoggedIn && hasLoadedHasSubscription;

    if (!hasLoaded) {
      return SHOW_STATUS.SHOW_NULL;
    }

    if (isLoggedIn && hasLoadedHasSubscription && !hasSubscription) {
      return SHOW_STATUS.SHOW_NO_ACCESS_ALLOWED;
    }
  };

  render() {
    const showStatus = this.getShowStatus();

    switch (showStatus) {
      case SHOW_STATUS.SHOW_NULL:
        return null;
      case SHOW_STATUS.SHOW_NO_ACCESS_ALLOWED:
        return <NoAccessAllowed />;
      default:
        break;
    }

    return (
      <BrowserRouter>
        <div className="app">
          <div className="header">
            <Route component={Main} />
            <Toolbar />
          </div>
          <div className="content">
            <ErrorBoundary
              fallbackRender={ErrorBoundaryFallbackRenderer}
              onReset={() => this.props.dispatch(restorePreviousState())}
            >
              <Switch>
                <Route path={GROUPS_PATH} component={GroupsGrid} />
                <Route path={ACCOUNTS_PATH} component={AccountsGrid} />
                <Route path={GROUPS_ACCOUNTS_PATH} component={GroupsAccounts} />
                <Route path={JOURNALS_PATH} component={JournalsGrid} />
                <Route path={KPIS_PATH} component={KpiGrid} />
                <Route path={SETTINGS_PATH} component={SettingsScreen} />
                <Route path={HOME_PATH} component={GroupsAccounts} />
              </Switch>
            </ErrorBoundary>
          </div>
          <ModalsManager />
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;

  if (!auth) {
    return {
      hasLoadedIsLoggedIn: true,
      isLoggedIn: true,
      hasLoadedHasSubscription: true,
      hasSubscription: true,
    };
  }

  return {
    hasLoadedIsLoggedIn: state.auth.hasLoadedIsLoggedIn,
    isLoggedIn: state.auth.isLoggedIn,
    hasLoadedHasSubscription: state.auth.hasLoadedHasSubscription,
    hasSubscription: state.auth.hasSubscription,
  };
};

export default connect(mapStateToProps)(App);
